import React, {createRef} from 'react'
import Page from './Page'
import LayerTools from './Layers/LayerTools'
import { inject, observer } from 'mobx-react'
import ContextMenu from './ContextMenu'
import { ReactComponent as TrashIcon } from "../../svg/trash-side.svg";
import { ReactComponent as ToolsToggle } from "../../svg/arrow-down.svg";
import { ReactComponent as AddIcon } from "../../svg/add-page-side.svg";
import { ReactComponent as CopyIcon } from "../../svg/duplicate-side.svg";
import { ReactComponent as ShiftUpIcon } from "../../svg/up-side.svg";
import { v4 as uuidv4 } from 'uuid'
import { ReactComponent as ShiftDownIcon } from "../../svg/down-side.svg";
import SelectBox from './Layers/SelectBox'
import { autorun } from 'mobx'
import Zoom from "./Zoom"
import workAreaStore from '../../store/workAreaStore'
import ToastAlert from '../Inputs/ToastAlert'
import LoadingScreen from './LoadingScreen'
import PickerColor from './PickerColor'
import MockupSidebar from '../Mockup/MockupSidebar'

@inject(
  'workAreaStore', 
  'mockupStore', 
  'templateStore', 
  'errorStore', 
  'photoStore', 
  'store', 
  'layerStore', 
  'saveStore', 
  'viewStore',
  'sidebarStore', 
  'historyStore'
) @observer
class WorkArea extends React.Component {

  constructor(props){
    super(props)
    this._saveInterval = null
    this._scrollTime = null
    this.state = {
      keyMap: {
        
      },
      imgs: {}
    }
    this.pageRef = createRef()
    this.workAreaRef = createRef()
    this.pasteRef = createRef()
    this.fullareaRef = createRef()
  }
  render(){
    return (
        <div className="workarea">
      </div>
    )
  }

  checkIfInput(className){
    return typeof(className) === 'string' && className.includes('form-control') || className.includes('input')
  }

  openTools(id, status){
    if(this.props.workAreaStore.resizingPage){
      return
    }
    this.props.workAreaStore.togglePageTools(id, status)
    const zoom = this.props.workAreaStore.zoom / 100
    if(status){
      const pageId = btoa(id)
      const toolsElement = document.querySelector(`[data-tools-id="${pageId}"]`)
      const page = document.querySelector(`[data-id="${pageId}"]`)
      if(toolsElement && page){
        if(page.offsetHeight * zoom <= toolsElement.offsetHeight / zoom){
          this.props.workAreaStore.pages.forEach(page => {
            if(page.id !== id){
              this.props.workAreaStore.togglePageTools(page.id, false)
            }
          })
        }
      }
    }
  }

  async componentDidMount(){
    const { workAreaStore, store, templateStore, sidebarStore, photoStore } = this.props
    const root = document.querySelector('#root')
    if(root && !root.classList.value.includes('editor')){
      root.classList.add('editor')
    }
    var userAgent = navigator.userAgent.toLowerCase(); 
    if (userAgent.indexOf('safari')!=-1){
       if(userAgent.indexOf('chrome')  > -1){
         //browser is chrome
       }else if((userAgent.indexOf('opera')  > -1)||(userAgent.indexOf('opr')  > -1)){
         //browser is opera 
       }else{
         root.classList.add('safari')
        //browser is safari, add css
       }
    }
    this.props.viewStore.checkIfMobileView()
    this.workAreaRef = createRef()
    await Promise.all([
      store.fetchPricingData(),
      store.checkAuthStatus(),
    ])
    //Doesnt have to async
    const itemId = window.localStorage.getItem('designId')
    const params = new URLSearchParams(window.location.search)
    const preloadId = params.get('designId')
    const localPreload = window.localStorage.getItem('preload')
    if(!store.auth && (!preloadId || localPreload && preloadId && localPreload === preloadId) && itemId && itemId !== 'null'){
      await workAreaStore.compileLocalDesign(JSON.parse(window.localStorage.getItem('design')))
      this.compiled = true
    }else{
      if(workAreaStore.pages.length === 0){
        await workAreaStore.createDefaultPage()
      }
    }
    if(store.auth){
      if(workAreaStore.pages.length === 0){
        await workAreaStore.createDefaultPage()
      }
      workAreaStore.populateBrands()
      templateStore.populateUserDesigns()
      if(store.subscription){
        const isSocialRedirect = params.get('socialAuth')
        if(isSocialRedirect){
          store.toggleShareModal(true)
        }
      }
    }
    const updateSize = () => {
      this.props.viewStore.checkIfMobileView()
      if (this.workAreaRef && this.workAreaRef.current) {
        this.props.workAreaStore.setWorkAreaSize(this.workAreaRef.current.clientHeight, this.workAreaRef.current.clientWidth)
      }
    }
    setTimeout(() => {
      window.addEventListener('mouseover', () => {
        if(this.props.workAreaStore.editingTextId){
          document.onselectstart = () => true
        }else{
          document.onselectstart = () => false
        }
      });
      window.addEventListener('mouseout', () => {
        if(this.props.workAreaStore.editingTextId){
          document.onselectstart = () => true
        }else{
          document.onselectstart = () => false
        }
      });
    }, 2000)
    window.onbeforeunload = () => {
      this.props.saveStore.saveDesign(true, true, true, true, true)
      if(window.gifRenderers){
        window.gifRenderers.forEach(renderer => {
          renderer.freeWorkers.forEach(worker => worker.terminate())
        })
      }
    }
    window.addEventListener('mousemove', e => {
      return
      try{
        if(this.props.workAreaStore.cursorPicker){
          let style = e.target.style
          let color = null
          const isLayer = e.target.classList && e.target.classList.value === 'layer-content'
          let layerImg = false
          let layerId = null
          if(isLayer){
            const id = e.target.parentNode.getAttribute('data-id')
            layerId = id
            layerImg = document.querySelector(`[data-id="${id}"] .layer-content .photo-layer img`)
          }else{
            if(e.target.className && e.target.className === 'workarea__page__layers'){
              const parent = e.target.parentNode
              style = parent.style
            }
          }
          const cb = (color) => {
            this.props.workAreaStore.setCursorColor(color)
          }
          if(layerImg){
            const { left, top } = layerImg.getBoundingClientRect()
            const zoom = this.props.workAreaStore.zoom / 100
            const x = (e.clientX - left) / zoom
            const y = (e.clientY - top) / zoom
            if(!this.state.imgs[layerId]){
              const img = new Image();
              img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const { data } = ctx.getImageData(x + 20, y + 20, 1, 1)
                color = `rgba(${data[0]}, ${data[1]}, ${data[2]}, ${data[3] / 255})`
                cb(color)
                this.setState({
                  imgs: {
                    ...this.state.imgs,
                    [layerId]: ctx
                  }
                })
              }
              img.setAttribute('crossOrigin', 'anonymous');
              img.src = layerImg.src;
            }else{
              const img = this.state.imgs[layerId]
              const { data } = img.getImageData(x, y + 10, 1, 1)
              color = `rgba(${data[0]}, ${data[1]}, ${data[2]}, ${data[3] / 255})`
              cb(color)
            }
            return
          }else{
            const props = [
              'backgroundColor',
              'background',
              'stroke',
              'fill',
            ]
            let found = false
            props.forEach(prop => {
              if(style[prop] && !found){
                color = style[prop]
                found = true
              }
            })
          }
          if(color){
            this.props.workAreaStore.setCursorColor(color)
          }else{
            color = `rgba(255, 255, 255, 1)`
            this.props.workAreaStore.setCursorColor(color)
          }
        }
      }catch(err){
        console.log(err)
      }
    })
    window.addEventListener('paste', async e => {
      const { clipboardData } = e
      //console.log(clipboardData.types[0])
      const [ type ] = clipboardData.types
      let isRawSVG = false
      if(type && type === 'text/plain'){
        const d = clipboardData.getData('text/plain')
        isRawSVG = d.includes('<svg') && d.includes('</svg>')
      }
      let tempFile = null
      if(isRawSVG){
        const data = clipboardData.getData('text/plain')
        const svg = new Blob([data], { type: 'text/plain' })
        const name = `${uuidv4()}.svg`
        tempFile = new File([svg], name, { type: 'image/svg+xml' })
      }
      if((clipboardData && clipboardData.files.length || tempFile) && !workAreaStore.copiedLayer && !workAreaStore.cutLayer){
        const [fl] = clipboardData.files
        if(!fl && !tempFile){
          return false
        }
        if(store.auth && !photoStore.uploading){
          if((clipboardData.files && clipboardData.files.length > 0 || tempFile)){
            let file = tempFile
            if(!tempFile){
              file = e.clipboardData.files[0]
            }
            const { errorStore } = this.props
            const whitelist = ['image/svg+xml', 'image/png', 'image/jpeg', 'image/jpg']
            if(!file){
              return
            }
            if(whitelist.includes(file.type)){
              const name = file.name
              errorStore.setErrorMessage('Uploading ' + name, false)
              const data = await photoStore.uploadImage(file, workAreaStore.designId, workAreaStore.activeBrand)
              if(data){
                if(data.parsedSVG){
                  const { name, parsedSVG, assetColors, rawSVG } = data
                  errorStore.setErrorMessage('Uploaded ' + name ? name : 'SVG' + ' successfully', false)
                  workAreaStore.insertSVGElement(
                    { parsedSVG, assetColors, rawSVG }, 
                    workAreaStore.pages[0].width, 
                    workAreaStore.pages[0].height,
                    true
                  )
                }else{
                  const { name, url, assetId } = data
                  errorStore.setErrorMessage('Uploaded ' + name ? name : 'photo' + ' successfully', false)
                  this.props.workAreaStore.insertPhotoFromPaste(url, assetId)
                }
              }else{
                errorStore.setErrorMessage('Failed to upload ' + name + ' try uploading the image again')
              }
            }else{
              const [n, fileType] = file.type.split('/')
              errorStore.setErrorMessage(`Cannot upload ${fileType} file. Only svg, png, and jpeg files are supported.`)
            }
          }
        }else{
          return
        }
      }else if(workAreaStore.copiedLayer || workAreaStore.cutLayer){
        e.preventDefault()
        let id = ''
        if(workAreaStore.cutLayer){
          id = workAreaStore.cutLayer.id
        }else{
          id = workAreaStore.copiedLayer.id
        }
        this.props.workAreaStore.copyLayer(id)
      }
    })
    setTimeout(() => {
      updateSize()
    }, 1)
    document.body.addEventListener('mouseleave', e => {
      this.props.workAreaStore.handleResizeBarMouseUp()
      this.props.workAreaStore.handleBackgroundResizeMouseUp()
      this.props.layerStore.handleDrawMouseUp()
      this.props.workAreaStore.handleResizeMouseUp()
      this.props.workAreaStore.handleLayerMoveMouseUp()
      this.props.workAreaStore.handleBackgroundMoveMouse(0, 0, true)
      return
    })
    document.body.addEventListener('dragenter', e => {
      if(e.dataTransfer && e.dataTransfer.items.length && !this.props.workAreaStore.resizingPage){
        e.preventDefault()
        document.querySelector('.hidden-upload').style.display = 'initial'
      }else{
        document.querySelector('.hidden-upload').style.display = 'none'
      }
    })
    document.body.addEventListener('dragover', e => {
      e.preventDefault()
    })
    document.body.addEventListener('dragleave', e => {
      //document.querySelector('.hidden-upload').style.display = 'none'
    })
    document.addEventListener('dragstart', e => {
      let dragIcon = document.createElement('img')
      dragIcon.src = 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
      dragIcon.width = 0
      dragIcon.height = 0
      dragIcon.opacity = 0
      //e.dataTransfer.setDragImage(dragIcon, 0, 0);
      return false
    })
    window.addEventListener('resize', updateSize.bind(this));
    document.body.addEventListener('keyup', e => {
      if(this.checkIfInput(e.target.className)){
        //e.preventDefault()
        e.target.focus()
        return
      }
      if(this.props.workAreaStore.editingTextId){
        return
      }
      this.handleKey(e.keyCode, false, e)
    })
    document.body.addEventListener('keydown', e => {
      if(this.props.workAreaStore.editingTextId){
        return
      }
      if(this.checkIfInput(e.target.className)){
        e.target.focus()
        return
      }
      this.handleKey(e.keyCode, true, e)
    })
    this.fullareaRef.onwheel = e => {
      this.handleScroll(e)
    }
    this.props.layerStore.initSelectBox()
    //Save the design every 10 seconds
    this._saveInterval = setInterval(() => this.props.saveStore.saveDesign(), 10000)
    /*
    setTimeout(() => {
      this.props.saveStore.saveDesign()
    }, 10000)
    setTimeout(() => {
      this.props.saveStore.saveDesign()
    }, 30000)
    setTimeout(() => {
      this.props.saveStore.saveDesign()
    }, 60000)
    /*
    setTimeout(() => {
      clearInterval(this._saveInterval)
    }, 40000)
    */
    await this.props.store.fetchTeam()
    if(this.props.store.isTeam){
      templateStore.populateUserDesigns(null, this.props.store.teamDetails._id)
    }
    templateStore.populatePublicDesigns()
    setTimeout(() => {
      window.addEventListener('click', e => {
        if(document.querySelector('.hidden-upload')){
          document.querySelector('.hidden-upload').style.display = 'none'
        }
      })
    }, 1000)
    if(this.props.workAreaStore.mockupBase){
      this.props.mockupStore.updateMockup(true)
    }
  }

  componentWillUnmount(){
    window.removeEventListener('paste')
  }

  handleKey(code, status, event){
    const keyMap = { ...this.state.keyMap }
    keyMap[code] = status
    const { ctrlKey, metaKey, altKey, target: { className } } = event
    if(typeof(code) !== 'number'){
      return
    }
    const { workAreaStore } = this.props
    const whiteList = ['form-control', 'btn']
    if(className && typeof(className) === 'string' && whiteList.includes(className)){
      return
    }
    if(code === 86){
      return
    }
    if(ctrlKey || metaKey){
      event.preventDefault()
      event.stopImmediatePropagation()
    }
    let layer
    if(workAreaStore.selectedLayer){
      layer = this.props.workAreaStore.getLayer(workAreaStore.selectedLayer)
    }
    if(layer && layer.locked){
      event.preventDefault()
      return
    }
    if (altKey) {
      keyMap[18] = status
    }
    if(ctrlKey){
      keyMap[17] = status
    }
    if(metaKey){
      keyMap[91] = status
    }
    if(status){
      const ctrl = ctrlKey || metaKey
      //Backspace OR delete pressed
      if(keyMap[46] || keyMap[8] && !workAreaStore.editingTextId && workAreaStore.selectedLayer){
        this.props.workAreaStore.deleteLayerById(workAreaStore.selectedLayer)
      }
      //Cmd + P pressed
      if(ctrl && keyMap[80]){
        this.props.store.togglePublish(!this.props.store.publishOpen, workAreaStore.designId)
        keyMap[80] = false
      }
      //CMD + A pressed
      if(ctrl && keyMap[65]){
        workAreaStore.groupAllOnPage()
        keyMap[65] = false
      }
      //CMD + C pressed
      if(ctrl && keyMap[67]){
        if(this.props.workAreaStore.selectedLayer){
          workAreaStore.setCopiedLayer(workAreaStore.selectedLayer)
        }
        keyMap[67] = false
      }
      //CMD + X pressed
      if(ctrl && keyMap[88]){
        workAreaStore.cutLayerFromPage()
        keyMap[88] = false
      }
      //Cmd + V pressed
      /*
      if(ctrl && keyMap[86]){
        if(workAreaStore.copiedLayer || workAreaStore.cutLayer){
          let id = ''
          if(workAreaStore.cutLayer){
            id = workAreaStore.cutLayer.id
          }else{
            id = workAreaStore.copiedLayer.id
          }
          this.props.workAreaStore.copyLayer(id)
        }
        keyMap[86] = false
      }
      */
      //Delete or backspace key pressed
      if(!ctrl && (keyMap[8] || keyMap[46]) && this.props.workAreaStore.selectedLayer){
        //workAreaStore.deleteLayerById(this.props.workAreaStore.selectedLayer, false)
      }
      //Control + Z pressed
      if(ctrl && keyMap[90] && !keyMap[16]){
        this.props.workAreaStore.undo()
        keyMap[90] = false
      }
      //Control + shift + Z pressed
      if(ctrl && keyMap[16] && keyMap[90]){
        this.props.workAreaStore.redo()
        keyMap[90] = false
        keyMap[16] = false
      }
      //Control + S pressed
      if(ctrl && keyMap[83]){
        if(this.props.saveStore.canSave){
          this.props.saveStore.saveDesign()
          keyMap[83] = false
          this.props.saveStore.setCanSave(false)
          setTimeout(() => {
            this.props.saveStore.setCanSave(true)
          }, 2000)
        }
      }
      const isLayer = workAreaStore.selectedLayer
      const layer = workAreaStore.getSelectedLayer()
      if(isLayer && layer){
        const { id } = layer
        const el = document.querySelector(`[data-id="${btoa(id)}"]`)
        if(!el){
          return
        }
        const { top, left } = el.getBoundingClientRect()
        workAreaStore.handleLayerMoveMouseDown(left, top, true)
        //Arrow left pressed
        let px = 1
        if(keyMap[16] && isLayer){
          px = 10
        }
        if(isLayer && !workAreaStore.editingTextId && keyMap[37]){
          keyMap[37] = false
          workAreaStore.moveLayer(layer, left - px, top)
          event.preventDefault()
        }
        //Arrow right pressed
        if(isLayer && !workAreaStore.editingTextId && keyMap[39]){
          keyMap[39] = false
          workAreaStore.moveLayer(layer, left + px, top)
          event.preventDefault()
        }
        //Arrow up pressed
        if(isLayer && !workAreaStore.editingTextId && keyMap[38]){
          keyMap[38] = false
          workAreaStore.moveLayer(layer, left, top - px)
          event.preventDefault()
        }
        if(isLayer && !workAreaStore.editingTextId && keyMap[40]){
          keyMap[40] = false
          workAreaStore.moveLayer(layer, left, top + px)
          event.preventDefault()
        }
        [37, 38, 39, 40].forEach(k => {
          keyMap[k] = false
        })
      }
    }
    if(!status && code === 16){
      keyMap[16] = false
    }
    if(!status){
      workAreaStore.handleLayerMoveMouseUp()
    }
    this.setState({ keyMap })
  }

  componentWillUnmount(){
    clearInterval(this._saveInterval)
    clearTimeout(this._scrollTime)
    this.fullareaRef.onwheel = null
  }

  handleScroll(e){
    const { ctrlKey, metaKey } = e
    if(ctrlKey || metaKey){
      let val = e.deltaY
      if(val % 1 !== 0){
        val *= -1
      }
      e.preventDefault()
      e.stopImmediatePropagation()
      this._scrollTime = setTimeout(() => {
        this.scrollZoom(val)
      }, 150)
    }
    return false
  }

  scrollZoom(deltaY){      
    const { workAreaStore } = this.props
    if(deltaY > 0){
      const newZoom = workAreaStore.zoom + 1
      if(newZoom > 200){
        clearTimeout(this._scrollTime)
        return
      }
      workAreaStore.updateZoom(newZoom)
    }else{
      const newZoom = workAreaStore.zoom - 1
      if(newZoom < 10){
        clearTimeout(this._scrollTime)
        return
      }
      workAreaStore.updateZoom(newZoom)
    }
  }

  handleMouseMove(e){
    const { 
      workAreaStore, 
      workAreaStore: {
        isSelecting,
        resizingPage,
        pageResizeDown,
        resizingLayerBar,
        cursorPicker,
        draggingBackground,
        resizingLayer,
        isKeyboard,
        isToolbox,
        editingTextId,
        rotate,
        movingLayer
      },
      sidebarStore
    } = this.props
    const keyMap = { ...this.state.keyMap }
    if(workAreaStore.pages.length === 0){
      return
    }
    if(cursorPicker){
      workAreaStore.setCursorLocation(e.clientX, e.clientY)
      return
    }
    if(!editingTextId){
      e.preventDefault();
    }
    const selectedLayer = workAreaStore.getSelectedLayer()
    if(selectedLayer && selectedLayer.locked && !isSelecting){
      return
    }
    let pageIdx = 0
    workAreaStore.pages.forEach((page, index) => {
      const pageLayerIds = page.layers.map(({ id }) => id)
      if(selectedLayer && pageLayerIds.includes(selectedLayer.id)){
        pageIdx = index
      }
    })
    const page = workAreaStore.pages[pageIdx]
    const layerIndex = workAreaStore.pages[pageIdx].layers.findIndex(({ selected }) => selected)
    const layer = page.layers[layerIndex]
    const { clientX, clientY } = e
    if(isSelecting && !resizingLayer && !resizingPage && !pageResizeDown && !rotate && !workAreaStore.editingTextId && !resizingLayerBar){
      this.props.layerStore.drawBox(clientX, clientY)
      return
    }
    let className = e.target.className
    if(layer && (layer.type === 'svg' || layer.type === 'svgGroup') && typeof(className) === 'object'){
      className = 'svg'
    }
    const stringClass = typeof(className) === 'string'
    if(resizingPage && pageResizeDown && stringClass){
      this.props.workAreaStore.resizePageBackground(clientX, clientY)
      return
    }
    const isDragging = stringClass && (className.includes('workarea__page__cropper-image') || className.includes('workarea__page__cropper-overlay'))
    if(resizingPage && isDragging && draggingBackground && !pageResizeDown){
      this.props.workAreaStore.movePageBackground(clientX, clientY)
      return
    }
    if(movingLayer && !isKeyboard && !isSelecting && !resizingLayer && !rotate){
      let targetLayer = document.querySelector('.layer.selected')
      if(!targetLayer){
        targetLayer = document.querySelector('.workarea__text-page__text-wrapper')
      }
      if(!targetLayer){
        return
      }
      if (layerIndex >= 0 && !editingTextId) {
        workAreaStore.moveLayer(layer, clientX, clientY)
        const { x, y } = workAreaStore.snapCheck(pageIdx, selectedLayer)
        workAreaStore.translateLayers(layer, -1 * x, -1 * y)
        workAreaStore.guideLineCheck(pageIdx, selectedLayer)
      }
      const selection = window.getSelection()
      if(editingTextId && layerIndex >= 0 && typeof(className) === 'string' && (className.includes('toolbox__move') || className.includes('workarea__page'))){
        if(selection && selection.anchorNode.nodeName === '#text'){
          return
        }
        e.preventDefault()
        e.stopPropagation()
        workAreaStore.moveLayer(layer, clientX, clientY)
        const { x, y } = workAreaStore.snapCheck(pageIdx, selectedLayer)
        workAreaStore.translateLayers(layer, -1 * x, -1 * y)
        workAreaStore.guideLineCheck(pageIdx, selectedLayer)
      }
    } else if ((resizingLayer || resizingLayerBar) && !isSelecting && !rotate){
      const target = document.querySelector('.workarea__layer-tools__toolbox')
      if(editingTextId){
        e.preventDefault()
        e.stopPropagation()
      }
      if(target && !movingLayer && !resizingLayerBar){
        const { x: offsetX, y: offsetY } = target.getBoundingClientRect()
        workAreaStore.resizeLayer(clientX, clientY, offsetX, offsetY, layer)
        workAreaStore.guideLineCheck(pageIdx, selectedLayer)
      }
      if(target && !isSelecting && !resizingLayer){
        const { x: offsetX, y: offsetY } = target.getBoundingClientRect()
        workAreaStore.resizeLayerBar(clientX, clientY, offsetX, offsetY, layer, keyMap[18])
        workAreaStore.guideLineCheck(pageIdx, selectedLayer)
      }
    } else if (rotate && !isSelecting && !resizingLayer) {
      let targetLayer = document.querySelector('.layer.selected')
      if(!targetLayer){
        targetLayer = document.querySelector('.workarea__text-page__text-wrapper')
      }
      if(!targetLayer){
        return
      }
      const target = targetLayer.children[0]
      if (layerIndex >= 0) {
        const { x, y, width, height } = target.getBoundingClientRect()
        workAreaStore.rotateLayer(layer, clientX, clientY, x, y, width, height, false, keyMap[16])
        workAreaStore.guideLineCheck(pageIdx, selectedLayer)
      }
    }
    // workAreaStore.guideLineCheck(pageIdx, selectedLayer)
  }

  toggleMouseClick(e, start = true){
    const { clientX, clientY } = e
    const { workAreaStore, historyStore, sidebarStore, layerStore } = this.props
    let { className, nodeName } = e.target
    this.props.store.closeAll()
    if(!workAreaStore.pages || workAreaStore.pages.length === 0){
      return
    }
    if(workAreaStore.settingText){
      return
    }
    try{
      const slide = sidebarStore.getActiveSlide()
      const wl = ['background', 'color-picker-page', 'color-picker']
      if(this.props.workAreaStore.cursorPicker && slide && wl.includes(slide.id)){
        return
      }
      if(this.props.workAreaStore.cursorPicker && (!slide || !wl.includes(slide.id))){
        this.props.workAreaStore.setCursorPicker(false)
      }
      workAreaStore.toggleAlign(false)
      workAreaStore.toggleShift(false)
      if(className === ''){
        const p = e.target.parentNode
        if(p.className){
          className = e.target.parentNode.className
        }
      }
      if(!start){
        workAreaStore.handleResizeBarMouseUp()
        workAreaStore.handleBackgroundResizeMouseUp()
        layerStore.handleDrawMouseUp()
        workAreaStore.handleResizeMouseUp()
        workAreaStore.handleLayerMoveMouseUp()
        workAreaStore.handleRotateMouseUp()
        this.props.workAreaStore.handleBackgroundMoveMouse(0, 0, true)
      }
      const layer = workAreaStore.getSelectedLayer()
      const isTextLayer = layer && layer.type === 'text'
      if(layer && layer.type !== 'svgGroup' && typeof(className) === 'object' && (nodeName === 'path' || nodeName === 'g') && !className.hasOwnProperty('baseVal')){
        let parent = e.target.parentNode
        if(parent.nodeName === 'path'){
          parent = parent.parentNode
        }
        if(parent.nodeName === 'g'){
          parent = parent.parentNode
        }
        if(parent.nodeName === 'g'){
          parent = parent.parentNode
        }
        if(parent.nodeName === 'svg'){
          className = parent.className.baseVal
        }
      }
      if(className && className.baseVal){
        className = className.baseVal
      }
      if(layer && (layer.type === 'svg' || layer.type === 'svgGroup') && typeof(className) === 'object'){
        className = 'svg'
      }
      if(!className || !className.includes){
        return
      }
      if(!className.includes('zoom')){
        workAreaStore.setZoomOpen(false)
      }
      const { resizingLayer, resizingLayerBar, groups, rotate, editingTextId, movingLayer } = workAreaStore
      const isText = className.includes('workarea-tools__text-layer') || className.includes('quill') || className.includes('ql-') || className.includes('text-layer__span')
      const isPage = className.includes('workarea__page') || className.includes('workarea__page__layers')
      const isLayer = className.includes('layer') || className === 'svg'
      const isOutside = className.includes('workarea__canvas-wrapper')
      const isTextPage = className.includes('workarea__text-page')
      if(isTextPage){
        workAreaStore.unsetAllEditingText()
        sidebarStore.closeSidebarSlide()
        new MouseEvent(e.type, e)
        return
      }
      if(isOutside && !start && workAreaStore.resizingPage){
        this.props.workAreaStore.handleBackgroundMoveMouse(0, 0, true)
        this.props.workAreaStore.handleBackgroundResizeMouseUp()
      }
      if(isOutside && start && !resizingLayerBar && !workAreaStore.resizingPage && !rotate && !resizingLayer && !movingLayer){
        this.props.workAreaStore.deselectSelectedLayer()
        //this.props.sidebarStore.closeSidebarSlide()
        if(!workAreaStore.resizingPage){
          this.props.workAreaStore.unsetActivePage()
          if(sidebarStore.pageFilters){
            sidebarStore.closeSidebarSlide()
          }
        }
        if(sidebarStore.textStyleOpen){
          this.props.sidebarStore.setTextStyleSlide(false)
        }
        workAreaStore.unsetAllEditingText()
        return
      }
      if(isPage && start){
        const pageId = atob(e.target.getAttribute('data-id'))
        if(!workAreaStore.resizingPage){
          workAreaStore.setActivePage(pageId)
        }
        workAreaStore.unsetAllEditingText()
        workAreaStore.deselectAllLayers()
        const slide = sidebarStore.getActiveSlide()
        if(sidebarStore.open && (slide.id === 'color-picker' || slide.id === 'svg-color-picker')){
          this.props.sidebarStore.closeSidebarSlide()
          sidebarStore.changeStatus('color-picker-page')
        }
        if((sidebarStore.open) && slide.id === 'filters'){
          this.props.sidebarStore.closeSidebarSlide()
        }
        if(sidebarStore.textStyleOpen){
          this.props.sidebarStore.setTextStyleSlide(false)
        }
      }
      const isContext = className.includes('context-menu')
      if(start && !isPage && !isContext && !workAreaStore.resizingPage){
        workAreaStore.unsetActivePage()
        if(sidebarStore.pageFilters){
          sidebarStore.closeSidebarSlide()
        }
      }
      const includesResizeBar = className.includes('workarea__layer-tools__toolbox__resize-bar')
      if((includesResizeBar || resizingLayerBar) && !resizingLayer && !rotate){
       // workAreaStore.unsetAllEditingText()
        if(start){
          workAreaStore.handleResizeBarMouseDown(clientX, clientY)
        }else{
          workAreaStore.handleResizeBarMouseUp()
        }
        return
      }
      const includesResize = className.includes('workarea__layer-tools__toolbox__dot')
      if((includesResize || resizingLayer) && !resizingLayerBar && !rotate){
        //workAreaStore.unsetAllEditingText()
        if(start){
          workAreaStore.handleResizeMouseDown(clientX, clientY)
        }else{
          workAreaStore.handleResizeMouseUp()
        }
        return
      }
      const includesRotate = className.includes('workarea__layer-tools__toolbox__rotate__icon') || className.includes('workarea__layer-tools__toolbox__rotate')
      if((includesRotate || rotate) && !resizingLayerBar && !resizingLayer){
        if(start){
          workAreaStore.handleRotateMouseDown(clientX, clientY)
        }else{
          workAreaStore.handleRotateMouseUp()
        }
        return
      }
      const includesPageResize = className.includes('workarea__page__cropper-dot')
      if(includesPageResize && workAreaStore.resizingPage){
        if(start){
          workAreaStore.handleBackgroundResizeMouseDown(clientX, clientY)
        }else{
          workAreaStore.handleBackgroundResizeMouseUp()
        }
      }
      const isDragging = className.includes('workarea__page__cropper-image') || className.includes('workarea__page__cropper-overlay')
      if(isDragging && workAreaStore.resizingPage){
        if(start){
          workAreaStore.handleBackgroundMoveMouse(clientX, clientY)
        }else{
          workAreaStore.handleBackgroundMoveMouse(0, 0, true)
        }
      }
      const groupLen = groups.length > 0
      const includesMove = className.includes('workarea__layer-tools__toolbox__move')
      const isBetween = className === 'workarea__page-wrapper'
      if(((isPage && !isBetween) || (!isPage && !isBetween && isLayer && layer && layer.locked)) && !editingTextId && !includesMove && !includesRotate && ((!isText) || (isText && layer && layer.locked)) && !includesResizeBar && !includesResize){
        if(start){
          if(groupLen > 0 && e.nativeEvent.which !== 3){
            workAreaStore.clearExistingGroup()
          }
          if(!workAreaStore.editingTextId){
            layerStore.handleDrawMouseDown(clientX, clientY)
          }
        }else{
          layerStore.handleDrawMouseUp()
          workAreaStore.handleLayerMoveMouseUp()
        }
        return
      }
      if((!isPage || isBetween) && !resizingLayer && !rotate){
        if(start){
          workAreaStore.handleLayerMoveMouseDown(clientX, clientY)
        }else{
          workAreaStore.handleLayerMoveMouseUp()
        }
        return
      }
      if(includesMove && !isPage && !rotate && !resizingLayer && !workAreaStore.editingTextId){
        e.preventDefault()
        if(start){
          workAreaStore.handleLayerMoveMouseDown(clientX, clientY)
        }else{
          workAreaStore.handleLayerMoveMouseUp()
        }
        return
      }
    }catch(err){
      console.log(err)
      console.log(className)
    } 
  }

  handleRegularClick(e){
    let className = e.target.className
    const { workAreaStore } = this.props
    if(className === ''){
      const p = e.target.parentNode
      if(p.className){
        className = e.target.parentNode.className
      }
    }
    if(className && className.baseVal){
      className = className.baseVal || ''
    }
    if(typeof(className) === 'object'){
      className = 'svg'
    }
    if(!className || !className.includes){
      return
    }
    if(!className.includes('context')){
      workAreaStore.toggleContextMenu(0, 0, false)
    }
  }

  toggleContextMenu(e){
    e.preventDefault()
    const { workAreaStore } = this.props
    if(workAreaStore.pages.length === 0){
      return
    }
    const { clientX, clientY } = e
    const { top, left } = document.querySelector('.workarea__page').getBoundingClientRect()
    const x = (clientX - left) + 15
    const y = (clientY - top) + 10
    workAreaStore.toggleContextMenu(x, y)
  }

  addPage(idx){
    this.props.workAreaStore.deselectAllLayers()
    this.props.workAreaStore.addNewPage(idx)
  }

  deletePage(id){
    this.props.workAreaStore.deselectAllLayers()
    this.props.workAreaStore.deletePageById(id)
  }

  shiftPage(id, down = true){
    this.props.workAreaStore.deselectAllLayers()
    this.props.workAreaStore.shiftPage(id, down)
  }

  copyPage(id){
    this.props.workAreaStore.deselectAllLayers()
    this.props.workAreaStore.copyPage(id)
  }

  calcMargins(zoomVal){
    const res = {
      relativeWidth: '100%'
    }
    const page = document.querySelector('.workarea__page')
    if(!page){
      return res
    }
    const { workAreaStore, mockupStore } = this.props
    let w = page.offsetWidth
    if(!w && this.props.workAreaStore.pages.length){
      w = workAreaStore.pages[0].width
    }
    if(mockupStore.sidebarOpen && workAreaStore.mockupBase){
      w += 300
    }
    const pageWidth = (w + 200) * zoomVal
    const screenWidth = document.body.clientWidth
    if(pageWidth < screenWidth){
      res.relativeWidth = '100%'
    }else{
      res.relativeWidth = pageWidth
    }
    return res
  }
  
  toggleCursorPicker(e){
    if(this.props.workAreaStore.cursorPicker){
      e.preventDefault()
      let color = this.props.workAreaStore.cursorColor
      const slide = this.props.sidebarStore.items.find(({ active }) => active)
      if(!color.includes('rgba')){
        const temp = color.split('')
        temp.splice(temp.length - 1, 1, ...[', ', '1', ')'])
        color = temp.join('')
        color = color.replace('rgb', 'rgba')
      }
      if(!slide || !slide.id){
        return
      }
      const isBackgroundSlide = slide && (slide.id === 'background') || (slide.id === 'color-picker-page')
      if(this.props.workAreaStore.selectedLayer && !isBackgroundSlide){
        const { pageIdx, layerIdx } = this.props.workAreaStore.findLayerIdx(this.props.workAreaStore.selectedLayer)
        if(pageIdx > -1 && layerIdx > -1){
          const layer = this.props.workAreaStore.pages[pageIdx].layers[layerIdx]
          if(layer.type === 'element'){
            this.props.workAreaStore.changeLayerProp(layer.id, 'fillHex', color)
            return
          }
        }
      }
      if(isBackgroundSlide && this.props.workAreaStore.activePage){
        this.props.workAreaStore.changePageProp(this.props.workAreaStore.activePage, 'background', color)
      }
      if(isBackgroundSlide && !this.props.workAreaStore.activePage){
        this.props.workAreaStore.pages.forEach(p => {
          this.props.workAreaStore.changePageProp(p.id, 'background', color)
        })
      }
    }
    this.props.workAreaStore.setCursorPicker(false)
  }

  render () {
    const { pages, contextMenu, hidden, resizingPage, compiled, cursorPicker, mockupBase, optimalSize, zoom: wkZoom } = this.props.workAreaStore
    const { sidebarOpen: mockupSidebarOpen } = this.props.mockupStore
    const zoom = this.props.workAreaStore.zoom / 100
    const optimalZoom = optimalSize / 100
    const { relativeWidth } = this.calcMargins(zoom)
    const iconHeight = zoom <= 0.5 ? 18 / zoom : 20 / zoom
    const iconMargin = zoom <= 0.3 ? 1 / zoom : zoom <= 0.5 ? 2.5 / zoom : 10 / zoom
    const { message, isError } = this.props.errorStore
    //this.props.workAreaStore.checkScroll()
    const iconStyle = {
      height: iconHeight + 'px',
      width: iconHeight + 'px',
      marginTop: iconMargin + 'px'
    }
    if(zoom <= 0.7){
      iconStyle.marginLeft = -20 / zoom + 'px'
    }
    if(zoom >= 1.2){
      iconStyle.marginLeft = 20 / zoom + 'px'
      iconStyle.marginTop = 7 + 'px'
    }
    if(zoom >= 1.65){
      iconStyle.height = '13.25px'
      iconStyle.width = '13.25px'
    }
    if(zoom >= 1.8){
      iconStyle.height = '12.5px'
      iconStyle.width = '12.5px'
    }
    /*
    if(zoom <= 0.2){
      iconStyle.height = '50px'
      iconStyle.width = '50px'
    }
    */
    const pageLen = pages.length
    const workAreaStyle = {}
    let heightVar = 200
    if(pages.length){
      const h = pages[0].height
      if(h < 700){
        heightVar = 200
      }
      if(h > 2000){
        heightVar = 400
      }
      if(h > 10000){
        heightVar = 600
      }
    }
    const canvasHeight = pages[0] ? (pages[0].height * zoom) * pageLen + ((heightVar * zoom) * pageLen) : ''
    if(zoom < optimalZoom){
      const h = pages[0].height
      const { height: wh } = document.querySelector('.full-workarea').getBoundingClientRect()
      const ph = ((h * pages.length) + heightVar) * zoom
      let middle = (wh - ph) / 2
      if(middle < 0){
        middle = 0
      }
      workAreaStyle.marginTop = middle + 'px'
    }
    return (
      <>
        <LoadingScreen style={{display: compiled ? 'none' : 'flex'}} />
        <div
          ref={this.pasteRef}
          style={{zIndex: '-10', position: 'absolute', top: '0', left: 0, width: '100%', height: '100%'}}
          contentEditable
        />
        <div
          onClick={e => this.toggleCursorPicker(e)}
          className={hidden || !compiled ? 'full-workarea hidden' : 'full-workarea'}
          style={{
            width: relativeWidth
          }}
          ref={ref => this.fullareaRef = ref}
          onPaste={e => this.handlePas}
        >
          <div className='workarea'
            onMouseDown={(e) => this.toggleMouseClick(e)}
            onMouseUp={(e) => this.toggleMouseClick(e, false)}
            onMouseMove={(e) => this.handleMouseMove(e)}
            onContextMenu={(e) => this.toggleContextMenu(e)}
            onClick={e => this.handleRegularClick(e)}
            style={{
              paddingRight: mockupBase && mockupSidebarOpen ? '300px' : 0
            }}
          >
            <div
              className='workarea__canvas-wrapper'
              ref={this.workAreaRef}
              style={{
                ...workAreaStyle,
                height: canvasHeight + 'px'
              }}
            >
              <div className='workarea__canvas'
              style={{
                transformOrigin: "center top",
                transform:
                  `scale(${zoom})`
                }}
              >
                <div 
                  className='workarea__page-wrapper'
                  ref={this.pageRef}
                >
                  {
                    pages.map((page, idx) => {
                      return (
                        <React.Fragment key={idx}>
                          <div className='page-options'
                            data-tools-id={btoa(page.id)}
                            style={{
                              top: idx === 0 ? 10 : (page.displayHeight * idx + 10) + (20 * idx)
                            }}
                          >
                            {
                              resizingPage || mockupBase ? (
                                undefined
                              )
                              :
                              (
                                zoom <= 0.5 && !page.toolsOpen ? (
                                  <ToolsToggle
                                    style={{
                                      ...iconStyle,
                                      'transform': 'scale(0.8)'
                                    }}
                                    onClick={() => this.openTools(page.id, !page.toolsOpen)} 
                                  />
                                )
                                :
                                (
                                  <React.Fragment>
                                    {
                                      zoom <= 0.5 && page.toolsOpen ? (
                                        <ToolsToggle 
                                          className='cursor-pointer' 
                                          style={{...iconStyle, 'transform': 'rotate(180deg) scale(0.8)'}} 
                                          onClick={() => this.openTools(page.id, false)} 
                                        />
                                      )
                                      :
                                      undefined
                                    }
                                    <TrashIcon 
                                      style={iconStyle}
                                      onClick={() => this.deletePage(page.id)} 
                                    />
                                    <AddIcon 
                                      style={iconStyle}
                                      onClick={() => this.addPage(idx)} 
                                    />
                                    <CopyIcon 
                                      style={iconStyle}
                                      onClick={() => this.copyPage(page.id)}
                                    />
                                    <ShiftUpIcon 
                                      style={iconStyle}
                                      onClick={() => this.shiftPage(page.id, false)} 
                                    />
                                    <ShiftDownIcon 
                                      style={iconStyle}
                                      onClick={() => this.shiftPage(page.id, true)} 
                                    />
                                  </React.Fragment>
                                )
                              )
                            }
                          </div>
                          <Page 
                            zoom={zoom}
                            {...page} 
                            index={idx}
                          />
                          {
                            <LayerTools 
                              index={idx} 
                            />
                          }
                          <div style={{ display:'block', height: '20px' }} className='sep' />
                          </React.Fragment>
                      )
                    })
                  }
                  {
                      contextMenu && contextMenu.display ? <ContextMenu {...contextMenu} /> : <div />
                  }
                </div>
                <div 
                  className='select-box-wrapper'
                >
                  <SelectBox />
                </div>
              </div>
            </div>
          </div>
          {
            cursorPicker ? (
              <PickerColor />
            )
            :
            undefined
          }
          <div 
            className="workarea__zoom-wrapper shadow"
            onMouseUp={(e) => this.toggleMouseClick(e, false)}
          >
            <Zoom 
              className=''
            />
          </div>
          <ToastAlert 
            message={message}
            isError={isError}
          />
        </div>
      </>
    )
  }
}

export default WorkArea
